import { TextField } from '@src/corelib/forms/generic';
export default function NotesField() {
  return <TextField multiline fullWidth label="Notes" name="notes" rows={5} />;
}
